<script>
export default {
  methods: {
    openUrl: function (url) {
      window.open(url, '_blank')
    },
    scrollToCategory: function () {
      setTimeout(() => {
        const selectAllCat = document.querySelector('a.categories-sponsors-text:not(.is-inactive)')
        if (selectAllCat) {
          // Extra wait time for the page to load on home page
          setTimeout(() => {
            selectAllCat.scrollIntoView({
              behavior: 'smooth'
            })
          }, 1000)
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      }, 1000)
    }
  }
}
</script>

<template>
  <div class="finalist-banner">
    <span class="finalist-banner-container">
      <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fbanner%2Fviewall%2FGroup.png?alt=media&token=0e411b1f-7703-4965-9d39-33b2cde77f07"
          class="finalist-banner-wave"/>
      <span class="finalist-banner-hero">
        <h1 class="finalist-banner-hero-title">
          2023 Finalist Projects
        </h1>
        <h6 class="finalist-banner-hero-description">
          Explore and engage with outstanding students from across the globe.
        </h6>
        <span class="finalist-banner-hero-btn-container">
          <button @click="() => {
              $router.push({ name: 'home' })
              scrollToCategory()
            }"
            class="button finalist-banner-hero-btn finalist-banner-hero-btn-primary">
            View All Projects <i class="fa-regular fa-arrow-right-long finalist-banner-hero-btn-icon" />
          </button>
          <button @click="openUrl('https://sspcdn.blob.core.windows.net/files/Documents/SEP/ISEF/2023/Finalist-Directory.pdf')"
                  class="button finalist-banner-hero-btn finalist-banner-hero-btn-secondary">
            Finalist Directory <i class="fa-regular fa-arrow-right-long finalist-banner-hero-btn-icon" />
          </button>
        </span>
      </span>
      <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fbanner%2Fviewall%2FGroup.png?alt=media&token=0e411b1f-7703-4965-9d39-33b2cde77f07"
           class="finalist-banner-wave finalist-banner-wave-alt"/>
    </span>
    <hr class="finalist-banner-hero-underline"/>
    <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fbanner%2Fviewall%2Fviewall-group-banner.png?alt=media&token=a8804151-8bf7-4456-ba99-57b106666d4f"
         class="finalist-banner-image"/>
    <div class="finalist-banner-bottom" />
  </div>
</template>

<style lang="scss" scoped>
.finalist-banner {
  position: relative;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fbanner%2Fviewall%2Fviewall-banner.png?alt=media&token=b6321a78-6f7f-4665-9cf2-7d3ca4cd9298");
  background-repeat: no-repeat;
  background-size: 100% 90%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  color: white;
  background-position: top;
  overflow: hidden;
  @media only screen and (max-width: 700px){
    background-position: center;
    background-size: 100% 150%;
  }
  &-bottom {
    background-image: url("https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fbanner%2Fviewall%2Fborder-viewall.png?alt=media&token=3fe7d550-61c4-4e22-a767-1bf28aebb002");
    background-size: contain;
    height: 130px;
    width: 100%;
    position: absolute;
    bottom: 0;
    background-repeat: repeat-x;
    background-position: bottom;
    @media only screen and (max-width: 700px){
      display: none;
    }
  }
  &-wave {
    width: 250px;
    @media only screen and (max-width: 1100px) {
      width: 150px;
    }
    @media only screen and (max-width: 900px) {
      display: none;
    }
    &-alt {
      transform: rotate(180deg);
    }
  }
  &-image {
    height: auto;
    margin-top: -2rem;
    @media only screen and (max-width: 1440px) {
      min-width: 1440px;
    }
    @media only screen and (max-width: 700px){
      display: none;
    }
  }
  &-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    justify-items: center;
    align-items: center;
    padding: 4rem 2rem 2rem 2rem;
    @media only screen and (max-width: 1440px){
      padding: 4rem 0 2rem 0;
    }
    @media only screen and (max-width: 900px){
      justify-content: center;
    }

    @media only screen and (max-width: 700px){
      padding: 1rem 0 0 0;
    }
  }
  &-hero {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    &-title {
      font-family: 'Trade Gothic Next LT Pro BdCn';
      font-style: normal;
      font-weight: 700;
      font-size: 59px;
      line-height: 74px;
      text-align: center;
      @media only screen and (max-width: 700px){
        font-size: 36px;
      }
    }
    &-description {
      font-family: 'Helvetica Neue';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 24px;
      padding: 1rem 0 1.5rem 0;
      text-align: center;
      @media only screen and (max-width: 1100px) {
        padding: 1rem 1rem 1.5rem 1rem;
      }
      @media only screen and (max-width: 700px) {
        font-size: 1em;
        width: 19rem;
        padding: 0 1rem;
      }
    }
    &-underline {
      display: none;
      width: 380px;
      height: 1px;
      background-color: #F4F4F4;
      @media only screen and (max-width: 700px) {
        display: inline-flex;
      }

      @media only screen and (max-width: 500px) {
        display: none;
      }
    }
    &-btn {
      font-family: 'Helvetica Neue';
      border-radius: 8px;
      height: 48px;
      width: 267px;
      color: #FFFFFF;
      font-weight: 500;
      font-size: 1em;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      @media only screen and (max-width: 700px) {
        font-size: .825em;
        width: 243px;
        height: 44px;
      }
      &-primary {
        background: #509DD7;
        border: none;
        @media only screen and (max-width: 700px) {
          display: none;
        }
      }
      &-secondary {
        background: transparent;
        border: 1px solid white;
        &:hover {
          background: #509DD7;
          border: 1px solid #509DD7;
        }
        @media only screen and (max-width: 500px) {
          display: none;
        }
      }
      &-icon {
        margin-top: .1rem;
        margin-left: .5rem;
      }
      &-container {
        padding-top: 1rem;
        display: flex;
        flex-direction: row;
        gap: 10px;
      }
    }
  }
}
</style>
